import * as Yup from 'yup';
import { MTA_ADDRESS_CHANGE_ERRORS } from '../constants/ErrorMessages';
import { FullPolicy } from '../../services/api';
import { Product } from '../../services/interface/Shared';

const ChangeOfUsageOrMileageSchema = (fullPolicy: FullPolicy) =>
	Yup.object({
		vehicleUse: Yup.string().required("Please select the best option that describes the vehicle's use"),
		levelOfCover: Yup.string().required('Please select the type of cover you require'),
		annualMileage: Yup.number().when([], {
			is: () => fullPolicy.product === Product.TAXI,
			then: (schema) => schema.notRequired(),
			otherwise: (schema) =>
				schema
					.min(0, MTA_ADDRESS_CHANGE_ERRORS.annualMileageGreaterThanZero)
					.required(MTA_ADDRESS_CHANGE_ERRORS.annualMileageRequired),
		}),
	});

export default ChangeOfUsageOrMileageSchema;
